import { jsx, jsxs } from "react/jsx-runtime";
import imgMemo from "../assets/print/img-memo.svg.js";
import imgQueda from "../assets/print/img-queda.svg.js";
function MemoPage({ pageWidth, pageHeight, bleedPx = 0 }) {
  const outerWidth = pageWidth + bleedPx * 2;
  const outerHeight = pageHeight + bleedPx * 2;
  const s = Math.min(pageWidth / 794, pageHeight / 1123);
  const cardW = 610 * s;
  const cardH = 949 * s;
  const cardLeft = (pageWidth - cardW) / 2;
  const cardTop = 88 * s;
  const linesLeft = 60 * s;
  const linesTop = 159 * s;
  const linesW = 491 * s;
  const lineCount = 15;
  const lineGap = 50 * s;
  const memoLeft = -12 * s;
  const memoTop = 42 * s;
  const quedaLeft = 346 * s;
  const quedaTop = 735 * s;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "print-page",
      "data-testid": "memo-page",
      style: {
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
        width: outerWidth,
        height: outerHeight,
        background: "#DEF2DA"
      },
      children: /* @__PURE__ */ jsx(
        "div",
        {
          "data-testid": "memo-page-trim",
          style: {
            position: "absolute",
            left: bleedPx,
            top: bleedPx,
            width: pageWidth,
            height: pageHeight
          },
          children: /* @__PURE__ */ jsxs(
            "div",
            {
              "data-testid": "memo-page-card",
              style: {
                position: "absolute",
                left: cardLeft,
                top: cardTop,
                width: cardW,
                height: cardH,
                background: "#ffffff",
                borderRadius: 40 * s,
                overflow: "visible"
              },
              children: [
                /* @__PURE__ */ jsx(
                  "svg",
                  {
                    "aria-hidden": "true",
                    style: {
                      position: "absolute",
                      left: linesLeft,
                      top: linesTop,
                      width: linesW,
                      height: cardH - linesTop,
                      overflow: "visible"
                    },
                    children: Array.from({ length: lineCount }, (_, i) => /* @__PURE__ */ jsx(
                      "line",
                      {
                        x1: 0,
                        y1: i * lineGap,
                        x2: i >= 12 ? 257 * s : linesW,
                        y2: i * lineGap,
                        stroke: "#B8B8B8",
                        strokeWidth: 2,
                        strokeLinecap: "round",
                        strokeDasharray: "3 6"
                      },
                      i
                    ))
                  }
                ),
                /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: imgMemo,
                    alt: "이곳에 메모해보세요",
                    style: {
                      position: "absolute",
                      left: memoLeft,
                      top: memoTop,
                      width: 267 * s,
                      height: 72 * s,
                      zIndex: 2
                    }
                  }
                ),
                /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: imgQueda,
                    alt: "queda",
                    style: {
                      position: "absolute",
                      left: quedaLeft,
                      top: quedaTop,
                      width: 229 * s,
                      height: 214 * s
                    }
                  }
                )
              ]
            }
          )
        }
      )
    }
  );
}
export {
  MemoPage
};
//# sourceMappingURL=MemoPage.js.map
